import { useEffect } from "react";
import Global from "../global";
import { useHistory } from "react-router-dom";
import { isLoggedin } from "../components/api/core";
import { VideoStore } from "../components/store/videoStore";
import InPlayer from "../components/backend/inplayer";

export default function useCheckVideo(video,AppId,props){
  let history = useHistory();
    useEffect(()=>
    {
      async function checkAccess(assetId,props,mediaid,app_id) {
        await InPlayer.Asset.checkAccessForAsset(assetId)
        .then((data )=> {  
           
           
        }).catch((error)=>{

          if(props.match.params.Type === "season")
          {
            let path = "/" + app_id + "/premium/"+assetId+"?redirect="+mediaid+"&type=season&after=premium&seasonid="+  props.match.params.Id;
            window.location.href=path;
          }
          else if(props.match.params.Type === "episode")
          {
            let path = "/" + app_id + "/premium/"+assetId+"?redirect="+mediaid+"&type=season&after=premium&seasonid="+  props.match.params.TypeId;
            window.location.href=path;
          }
          else
          {
            let path = "/" + app_id + "/premium/"+assetId+"?redirect="+mediaid+"&type=video&after=premium";
            window.location.href=path;
          }

         
        });
  }
       if(video)
       {
        if((Global.SUBSCRIPTION && Global.LOGIN))
        {
         
        }
        else
        {
          if((Global.SUBSCRIPTION || Global.LOGIN) && video.item.ContentType === "Authenticated")
          {
            if(!isLoggedin())
            {
              if(props.match.params.Type === "season")
              {
                let path = "/" + AppId + "/login?redirect="+video.item.mediaid+"&type=season&after=login&seasonid="+  props.match.params.Id;
                window.location.href=path;
              }
              else if(props.match.params.Type === "episode")
              {
                let path = "/" + AppId + "/login?redirect="+video.item.mediaid+"&type=season&after=login&seasonid="+  props.match.params.TypeId;
                window.location.href=path;
              }
              else
              {
                let path = "/" +AppId + "/login?redirect="+video.item.mediaid+"&type=video&after=login";
                window.location.href=path;
              }
             
            }
         
  
          }
          else if ((Global.SUBSCRIPTION || Global.LOGIN) && video.item.ContentType === "Premium")
          {
              if(VideoStore!==null)
              {
                 if(isLoggedin())
                 {
                  if(VideoStore.video_id!==video.item.mediaid || VideoStore.payment.item.id!==video.item.AssetId)
                  {
                    checkAccess(video.item.AssetId,props,video.item.mediaid,AppId);
                  }
                 
                 }
                 else
                 {
                  if(props.match.params.Type === "season")
                  {
                    let path = "/" + AppId + "/login?redirect="+video.item.mediaid+"&type=season&after=premium&seasonid="+  props.match.params.Id;
                    window.location.href=path;
                  }
                  else if(props.match.params.Type === "episode")
                  {
                    let path = "/" + AppId + "/login?redirect="+video.item.mediaid+"&type=season&after=premium&seasonid="+  props.match.params.TypeId;
                    window.location.href=path;
                  }
                  else
                  {
                    let path = "/" +AppId + "/login?redirect="+video.item.mediaid+"&type=video&after=premium";
                    window.location.href=path;
                  }
                 }
              }
              else
              {
                if(isLoggedin())
                {
                  checkAccess(video.item.AssetId,props,video.item.mediaid,AppId);
                
                }
                else
                {
                  if(props.match.params.Type === "season")
              {
                let path = "/" + AppId + "/login?redirect="+video.item.mediaid+"&type=season&after=premium&seasonid="+  props.match.params.Id;
                window.location.href=path;
              }
              else if(props.match.params.Type === "episode")
              {
                let path = "/" + AppId + "/login?redirect="+video.item.mediaid+"&type=season&after=premium&seasonid="+  props.match.params.TypeId;
                window.location.href=path;
              }
              else
              {
                let path = "/" +AppId + "/login?redirect="+video.item.mediaid+"&type=video&after=premium";
                window.location.href=path;
              }
                }
              }
          }
          else
          {
  
          }
        }
 
       }
       

    },[video,AppId,history,props])

}